const SET_PHONE_NUMBER ='SET_PHONE_NUMBER'
const SET_ID_KYC = 'SET_ID_KYC'
const SET_IDENTIFICATION_STATUS = 'SET_IDENTIFICATION_STATUS'
const SET_ERROR_STATUS = 'SET_ERROR_STATUS'
const SET_WEBPAGE_LANGUAGE = 'SET_WEBPAGE_LANGUAGE'

const initialState = {
    phoneNumber: '',
    idKYC: '',
    identificationStatus: '',
    errorStatus: '',
    appLanguage: 'en'
}

const AuthReducer = (state = initialState, action: any) => {
    switch(action.type){
        case SET_PHONE_NUMBER:
            return{
                ...state,
                phoneNumber: action.payload
            }
        case SET_ID_KYC:
            return{
                ...state,
                idKYC: action.payload
            }
        case SET_IDENTIFICATION_STATUS:
            return{
                ...state,
                identificationStatus: action.payload
            }
        case SET_ERROR_STATUS:
            return{
                ...state,
                errorStatus: action.payload
            }
        case SET_WEBPAGE_LANGUAGE:
            return{
                ...state,
                appLanguage: action.payload
            }
        default:
            return state
    }
}

export const setPhoneNumber = (payload :any) => ({type: SET_PHONE_NUMBER, payload})
export const setIDKYC = (payload :any) => ({type: SET_ID_KYC, payload})
export const setIdentificationStatus = (payload :any) => ({type: SET_IDENTIFICATION_STATUS, payload})
export const setErrorStatus = (payload :any) => ({type: SET_ERROR_STATUS, payload})
export const setLanguageWebsite = (payload :any) => ({type: SET_WEBPAGE_LANGUAGE, payload})

export default AuthReducer